export default {
  dataGrid_options: {},
  dataGridLogsValue: {},
  dataGrid_filterBuilders: {},
  dgRowInEditMode: {},
  dgInEditMode: {},
}
